import { Sanity$Product } from '@otovo/shared/types/sanityTypes';
import cx from 'classnames';
import ProductCardFeatures from './ProductCardFeatures';
import ProductImageCarousel from './ProductImageSlider';

type PriceCardProps = {
  product: Sanity$Product;
  displaySubscriptionPrice: boolean;
  priceContent: React.ReactNode;
};

const SingleProductPriceCard = ({
  product,
  displaySubscriptionPrice,
  priceContent,
}: PriceCardProps) => {
  return (
    <div
      className={cx(
        'relative flex flex-1 flex-col items-center justify-center rounded-lg border border-grey-20 bg-white lg:flex-row',
      )}
    >
      <div className="mt-4 w-full p-8 text-center">
        {product.productImages && (
          <ProductImageCarousel productImages={product.productImages} />
        )}
      </div>

      <div
        className={cx(
          'flex h-full w-full flex-col justify-center bg-lilac-5 text-grey-60',
          'rounded-b-xl p-4 py-6 md:px-20 lg:rounded-b-none lg:rounded-r-lg',
        )}
      >
        <div className="text-center text-grey-45 lg:text-left lg:text-lg">
          {product.fullProductName}
        </div>
        <div className="mb-10 border-b border-lilac-25 pb-6 text-center text-xl text-grey-60 lg:text-left lg:text-3xl ">
          {priceContent}
        </div>

        <ProductCardFeatures
          product={product}
          displaySubscriptionPrice={displaySubscriptionPrice}
        />
      </div>
    </div>
  );
};

export default SingleProductPriceCard;
